import { Box, useTheme } from '@mui/material';
import React, { FC } from 'react';

import { BreakPoints } from '../../theme/types';
import CardContent from '../Card/CardContent';
import CardMain from '../Card/CardMain';
import CardMainHeader from '../Card/CardMainHeader';
import Markdown from '../Markdown';

import { PageHeaderImageAndTextWrapper, PageHeaderText } from './index';

interface PageHeaderCardProps {
  menu?: JSX.Element;
  text: string;
  title: string;
}

const PageHeaderCard: FC<PageHeaderCardProps> = ({ menu, text, title }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        marginTop: '-5rem',
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        maxWidth: (theme.breakpoints.values.xl * 2) / 3,
        [theme.breakpoints.up(BreakPoints.Large)]: {
          paddingRight: '1.125rem',
        },
      }}
    >
      <CardMain>
        <CardContent>
          <PageHeaderImageAndTextWrapper>
            <PageHeaderText>
              <CardMainHeader float={menu} title={title} />
              <Markdown text={text ?? ''} />
            </PageHeaderText>
          </PageHeaderImageAndTextWrapper>
        </CardContent>
      </CardMain>
    </Box>
  );
};

export default PageHeaderCard;
